import styled from "@emotion/styled";

import { RadiusToken, ShadowToken, SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";

export const StyledSecondaryToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  padding: var(${SpacingToken.Spacing1}) var(${SpacingToken.Spacing2});
  box-shadow: var(${ShadowToken.Float});
  border-radius: var(${RadiusToken.Radius3});
  margin-bottom: var(${SpacingToken.Spacing2});

  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Tablet]}px) {
    margin-bottom: 0;
  }
`;

export const StyledMainToolbarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  margin-top: -1em;

  & > div {
    margin-top: 1em;
  }
`;

export const StyledIconsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  align-self: flex-end;

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    align-self: center;
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: default;
  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Tablet]}px) {
    padding: 9px;
    margin: -9px;
  }

  flex-wrap: wrap;

  button {
    margin-top: auto;
  }
`;

export const AtIcon = styled.span<{ privateMode?: boolean }>`
  font-size: 20px;
  display: block;
  padding-top: 1px;
  padding-bottom: 6px;
`;
